









































import {
  defineComponent,
  useContext,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'HydrogenNewsletter',
  props: {
    value: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    messageType: {
      type: String,
      default: '',
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    const { localePath } = useContext();
    const privacyPolicyPath = localePath('/web-privacy-policy');
    const onEmailInput = (event: Event) => {
      emit('input', (event.target as HTMLInputElement).value);
    };

    return {
      onEmailInput,
      privacyPolicyPath,
    };
  },
});
